/**
 * B_Image.js
 *
 * @목적 :
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import B_Real       from 'canvas/base/dev/child/base/B_Real';
import B_Image      from 'canvas/base/dev/child/image/B_Image';
import MixinBuilder from 'canvas/base/dev/scripts/MixinBuilder';

let mix = (superclass) => new MixinBuilder(superclass);

const B_ImageBG = (function(){

	return class extends mix(B_Real).with(B_Image) {

		constructor(obj) {
			super(obj);

			// [S] area
			this._setArea(
				this.CODMOS.CANVAS.width,
				this.CODMOS.CANVAS.height
			);
		}
	}
}());

export default B_ImageBG;



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/image/B_ImageBG.js